// extracted by mini-css-extract-plugin
export default {"dashboard":"dbq7ar","dashboard__logo":"iyMCq8","dashboardLogo":"iyMCq8"};